// src/components/StartScreen.jsx
import React, { useState } from "react";
import GoogleAd from "./GoogleAd";
import "./StartScreen.css";

function StartScreen({ onStart }) {
  const [jugadores, setJugadores] = useState([""]);
  const [nivelDificultad, setNivelDificultad] = useState("aleatorio");
  const [error, setError] = useState("");

  const handleNombre = (index, valor) => {
    const nuevos = [...jugadores];
    nuevos[index] = valor;
    setJugadores(nuevos);
  };

  const agregarJugador = () => {
    if (jugadores.length >= 6) return;
    setJugadores([...jugadores, ""]);
  };

  const quitarJugador = (index) => {
    if (jugadores.length <= 1) return;
    setJugadores(jugadores.filter((_, i) => i !== index));
  };

  const comenzar = () => {
  const lista = jugadores
    .map((p) => p.trim())
    .filter((p) => p.length > 0)
    .map((nombre) => ({
      nombre,
      progreso: {},
      historial: []
    }));

  if (lista.length === 0) {
    setError("Introduce al menos 1 jugador.");
    return;
  }
  setError("");
  onStart(lista, nivelDificultad);
};


  return (
    <div className="startscreen-container">
      <div className="start-card anim-fade-in">
        <h2 className="start-title">¡Juega y aprende con Carnetados!</h2>
        <p>Introduce los nombres de los jugadores:</p>

        <div className="players-list">
          {jugadores.map((p, i) => (
            <div className="player-input-row" key={i}>
              <input
                type="text"
                className="player-input"
                placeholder={`Jugador ${i + 1}`}
                value={p}
                maxLength={12}
                onChange={(e) => handleNombre(i, e.target.value)}
                autoFocus={i === jugadores.length - 1}
              />
              {jugadores.length > 1 && (
                <button
                  className="btn-mini btn-remove"
                  onClick={() => quitarJugador(i)}
                  title="Quitar jugador"
                  tabIndex={-1}
                >
                  ✖️
                </button>
              )}
            </div>
          ))}
          <button
            className={`btn-add-player ${jugadores.length >= 6 ? "disabled" : ""}`}
            onClick={agregarJugador}
            disabled={jugadores.length >= 6}
          >
            ➕ Añadir jugador
          </button>
        </div>

        <div className="difficulty-selector">
          <label>Selecciona la dificultad:</label>
          <select
            value={nivelDificultad}
            onChange={e => setNivelDificultad(e.target.value)}
            className="select-difficulty"
          >
            <option value="aleatorio">Aleatoria</option>
            <option value="fácil">Fácil</option>
            <option value="medio">Media</option>
            <option value="difícil">Difícil</option>
          </select>
        </div>

        <button className="btn-start-game anim-bounce" onClick={comenzar}>
          ▶️ Comenzar partida
        </button>
        {error && <div className="error-msg anim-shake">{error}</div>}
      </div>
      <GoogleAd />
    </div>
  );
}

export default StartScreen;
